(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      if (!bar || bar.dataset.annInit === '1') return;
      bar.dataset.annInit = '1';

      var key = 'ann-bar-dismissed';
      var ver = bar.getAttribute('data-ann-key') || '1';
      var closeBtn = bar.querySelector('[data-ann-close]');

      /* Daha önce kapatıldıysa (ve mesaj sürümü değişmediyse) gizle */
      try {
        if (closeBtn && window.localStorage.getItem(key) === ver) {
          document.documentElement.classList.add('ann-dismissed');
          bar.style.display = 'none';
          return;
        }
      } catch (e) {}

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          document.documentElement.classList.add('ann-dismissed');
          bar.style.display = 'none';
          try { window.localStorage.setItem(key, ver); } catch (e) {}
        });
      }

      /* Birden fazla mesaj varsa sırayla göster */
      var msgs = Array.prototype.slice.call(bar.querySelectorAll('[data-ann-msg]'));
      if (msgs.length > 1) {
        var i = 0;
        var speedStr = getComputedStyle(bar).getPropertyValue('--ann-rotate') || '4s';
        var speed = (parseFloat(speedStr) || 4) * 1000;
        setInterval(function () {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, speed);
      }
    }

    function initAll(scope) {
      var bars = (scope || document).querySelectorAll('[data-ann-bar]');
      Array.prototype.forEach.call(bars, initBar);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-save"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Active slide per section, so theme-editor re-renders (shopify:section:load)
    // restore the look you were editing instead of snapping back to the first.
    var activeSlideBySection = {};

    function sectionKey(root) {
      var wrap = root.closest ? root.closest('.shopify-section') : null;
      return wrap && wrap.id ? wrap.id : '';
    }

    function initRoot(root) {
      if (root.dataset.lookInit === '1') return;
      root.dataset.lookInit = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-look-slide]'));
      var prevBtn = root.querySelector('[data-look-prev]');
      var nextBtn = root.querySelector('[data-look-next]');
      var backdrop = root.querySelector('[data-look-backdrop]');
      var sid = sectionKey(root);
      var slideIndex = 0;

      // Her slide'ın çekmece paneli. Panel mobilde DOM'da taşınıyor (bkz. syncPortal),
      // o yüzden bundan sonra panele slide üzerinden değil bu referanstan erişiyoruz.
      var panels = slides.map(function (slide) {
        var panel = slide.querySelector('[data-look-panel]');
        if (panel) {
          slide.__panel = panel;
          panel.__slide = slide;
        }
        return panel;
      });

      function showSlide(i, keepDrawer) {
        slideIndex = (i + slides.length) % slides.length;
        activeSlideBySection[sid] = slideIndex;
        slides.forEach(function (slide, idx) {
          var on = idx === slideIndex;
          slide.hidden = !on;
          slide.classList.toggle('is-active', on);
        });
        if (!keepDrawer) closeDrawer();
      }

      // Expose a minimal API so editor block-select can drive the carousel.
      root.__lookApi = { slides: slides, showSlide: showSlide };

      function setActiveProduct(slide, index) {
        var panel = slide.__panel || slide;
        var hotspots = slide.querySelectorAll('[data-look-hotspot]');
        var products = panel.querySelectorAll('[data-look-product]');
        var dots = panel.querySelectorAll('[data-look-dot]');
        [hotspots, products, dots].forEach(function (list) {
          list.forEach(function (el) {
            var on = el.getAttribute('data-look-target') === String(index);
            el.classList.toggle('is-active', on);
          });
        });
      }

      function isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      var viewport = root.querySelector('.lookcarousel__viewport');

      // --- iOS düzeltmesi -------------------------------------------------
      // Panel, mobilde `.lookcarousel__viewport` (overflow-x:auto + scroll-snap)
      // içinde position:fixed idi. iOS Safari böyle bir sabit elemanı kaydırma
      // kabının boyama katmanına hapsediyor: çekmece, z-index'i daha yüksek
      // olmasına rağmen karartmanın ALTINDA kalıp bulanıklaşıyordu (Android'de
      // sorun yok). Çözüm: mobilde panelleri ve karartmayı kaydırıcının dışına,
      // body'ye eklenen tek bir kutuya taşımak. Böylece ikisi aynı yığın
      // bağlamında ve DOM sırası da (önce karartma, sonra panel) doğru oluyor.
      var portal = null;

      function ensurePortal() {
        if (portal) return portal;
        var stale = document.querySelector('[data-look-portal="' + sid + '"]');
        if (stale) stale.parentNode.removeChild(stale);
        portal = document.createElement('div');
        portal.className = 'lookcarousel__portal';
        portal.setAttribute('data-look-portal', sid);
        // --look-* özel değişkenleri section kökünde inline tanımlı. Panel
        // taşınınca onları kaybetmesin diye kopyalıyoruz; yoksa CTA butonu
        // marka kırmızısı yerine varsayılan siyaha düşer.
        var inline = root.getAttribute('style');
        if (inline) portal.setAttribute('style', inline);
        document.body.appendChild(portal);
        return portal;
      }

      function syncPortal() {
        if (isMobile()) {
          var host = ensurePortal();
          if (backdrop && backdrop.parentElement !== host) host.appendChild(backdrop);
          panels.forEach(function (panel) {
            if (panel && panel.parentElement !== host) host.appendChild(panel);
          });
        } else if (portal) {
          // Masaüstünde panel yine görselin yanındaki kart; yerine geri koy.
          panels.forEach(function (panel) {
            if (panel && panel.parentElement === portal && panel.__slide) panel.__slide.appendChild(panel);
          });
          if (backdrop && backdrop.parentElement === portal) root.appendChild(backdrop);
        }
      }

      function scrollViewportTo(i, smooth) {
        if (!isMobile() || !viewport || !slides[i]) return;
        var left = slides[i].offsetLeft - slides[0].offsetLeft;
        viewport.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      }

      function scrollStripTo(slide, index, smooth) {
        if (!isMobile()) return;
        var panel = slide.__panel;
        var strip = panel && panel.querySelector('[data-look-products]');
        if (!strip) return;
        var target = strip.querySelectorAll('[data-look-product]')[index];
        if (!target) return;
        strip.scrollTo({ left: target.offsetLeft - strip.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      function scrollMediaToTop(slide) {
        if (!isMobile()) return;
        var media = slide.querySelector('.lookcarousel__media');
        if (!media) return;
        var header = document.querySelector('.site-header');
        var headerHeight = header ? header.getBoundingClientRect().height : 0;
        var top = media.getBoundingClientRect().top + window.pageYOffset - headerHeight - 8;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }

      function openDrawer(slide) {
        var panel = slide.__panel;
        if (!panel) return;
        syncPortal();
        panels.forEach(function (p) {
          if (p && p !== panel) p.classList.remove('is-open');
        });
        panel.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
        document.documentElement.classList.add('look-drawer-open');
        scrollMediaToTop(slide);
        var active = panel.querySelector('[data-look-product].is-active');
        if (active) scrollStripTo(slide, parseInt(active.getAttribute('data-look-target'), 10) || 0, false);
      }

      function closeDrawer() {
        panels.forEach(function (p) {
          if (p) p.classList.remove('is-open');
        });
        if (backdrop) backdrop.classList.remove('is-open');
        document.documentElement.classList.remove('look-drawer-open');
      }

      slides.forEach(function (slide, slideIdx) {
        var panel = panels[slideIdx];
        slide.querySelectorAll('[data-look-hotspot]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var t = btn.getAttribute('data-look-target');
            setActiveProduct(slide, t);
            openDrawer(slide);
            scrollStripTo(slide, parseInt(t, 10) || 0, false);
          });
        });
        (panel || slide).querySelectorAll('[data-look-dot]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var t = btn.getAttribute('data-look-target');
            setActiveProduct(slide, t);
            scrollStripTo(slide, parseInt(t, 10) || 0, true);
          });
        });

        // Parmakla kaydırma: şerit kaydıkça aktif ürünü (nokta/hotspot) senkronla.
        var strip = panel && panel.querySelector('[data-look-products]');
        if (strip) {
          var stripTick = false;
          strip.addEventListener('scroll', function () {
            if (stripTick) return;
            stripTick = true;
            requestAnimationFrame(function () {
              stripTick = false;
              if (!isMobile()) return;
              var products = strip.querySelectorAll('[data-look-product]');
              if (!products.length || !strip.clientWidth) return;
              var mid = strip.scrollLeft + strip.clientWidth / 2;
              var best = 0;
              var bestDist = Infinity;
              products.forEach(function (p, i) {
                var center = p.offsetLeft - strip.offsetLeft + p.offsetWidth / 2;
                var d = Math.abs(center - mid);
                if (d < bestDist) { bestDist = d; best = i; }
              });
              setActiveProduct(slide, best);
            });
          }, { passive: true });
        }
        var openBtn = slide.querySelector('[data-look-open]');
        if (openBtn) openBtn.addEventListener('click', function () { openDrawer(slide); });
        (panel || slide).querySelectorAll('[data-look-close]').forEach(function (btn) {
          btn.addEventListener('click', closeDrawer);
        });
      });

      // Look şeridi kaydıkça aktif slide'ı senkronla (mobil).
      if (viewport && slides.length > 1) {
        var vpTick = false;
        viewport.addEventListener('scroll', function () {
          if (vpTick) return;
          vpTick = true;
          requestAnimationFrame(function () {
            vpTick = false;
            if (!isMobile()) return;
            var mid = viewport.scrollLeft + viewport.clientWidth / 2;
            var best = 0;
            var bestDist = Infinity;
            slides.forEach(function (s, i) {
              var center = s.offsetLeft + s.offsetWidth / 2;
              var d = Math.abs(center - mid);
              if (d < bestDist) { bestDist = d; best = i; }
            });
            if (best !== slideIndex) showSlide(best);
          });
        }, { passive: true });
      }

      if (backdrop) backdrop.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });

      // Panelleri doğru yere yerleştir; kırılım değişince (döndürme dahil) tazele.
      syncPortal();
      var mq = window.matchMedia('(max-width: 989px)');
      var onBreakpoint = function () { closeDrawer(); syncPortal(); };
      if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
      else if (mq.addListener) mq.addListener(onBreakpoint);

      if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(slideIndex - 1); scrollViewportTo(slideIndex, true); });
      if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(slideIndex + 1); scrollViewportTo(slideIndex, true); });

      // Restore the previously active look after a theme-editor re-render.
      var restore = activeSlideBySection[sid];
      if (typeof restore === 'number' && restore > 0 && restore < slides.length) {
        showSlide(restore, true);
        scrollViewportTo(restore, false);
      }

      root.__lookApi.scrollViewportTo = scrollViewportTo;
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-lookcarousel]');
      Array.prototype.forEach.call(roots, initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

    // Theme editor: when a Look block is selected, jump the carousel to it.
    function slideFromEvent(e) {
      var t = e.target;
      if (!t) return null;
      if (t.matches && t.matches('[data-look-slide]')) return t;
      return t.closest ? t.closest('[data-look-slide]') : null;
    }
    document.addEventListener('shopify:block:select', function (e) {
      var slide = slideFromEvent(e);
      if (!slide) return;
      var root = slide.closest('[data-lookcarousel]');
      var api = root && root.__lookApi;
      if (!api) return;
      var idx = api.slides.indexOf(slide);
      if (idx >= 0) {
        api.showSlide(idx, true);
        if (api.scrollViewportTo) api.scrollViewportTo(idx, true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.prodtabsInit === '1') return;
      root.dataset.prodtabsInit = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-prodtabs-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-prodtabs-panel]'));

      function bindCarousel(panel) {
        var track = panel.querySelector('[data-prodtabs-track]');
        if (!track || track.dataset.bound === '1') return;
        track.dataset.bound = '1';
        var bar = panel.querySelector('[data-prodtabs-bar]');
        var prev = panel.querySelector('[data-prodtabs-prev]');
        var next = panel.querySelector('[data-prodtabs-next]');

        function step() {
          var item = track.querySelector('.prodtabs__item');
          var gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap || '14px';
          var gap = parseFloat(gapStr) || 14;
          var w = item ? item.getBoundingClientRect().width : track.clientWidth * 0.5;
          return Math.max(w + gap, track.clientWidth * 0.8);
        }
        function refresh() {
          var max = track.scrollWidth - track.clientWidth;
          if (bar) {
            var p = max > 0 ? track.scrollLeft / max : 0;
            bar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0.1), 1) + ')';
          }
          if (prev) prev.disabled = track.scrollLeft <= 1;
          if (next) next.disabled = track.scrollLeft >= max - 1;
        }
        track.addEventListener('scroll', refresh, { passive: true });
        window.addEventListener('resize', refresh, { passive: true });
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

        /* ----- Advanced pointer drag: inertia + snap-to-card (desktop mouse) ----- */
        var down = false, startX = 0, startScroll = 0, moved = false;
        var lastX = 0, lastT = 0, vx = 0, raf = 0;

        function now() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

        function snapToNearest() {
          var item = track.querySelector('.prodtabs__item');
          if (!item) { refresh(); return; }
          var gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16px';
          var gap = parseFloat(gapStr) || 16;
          var unit = item.getBoundingClientRect().width + gap;
          var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          var rel = track.scrollLeft - pad;
          var target = Math.round(rel / unit) * unit + pad;
          var maxScroll = track.scrollWidth - track.clientWidth;
          target = Math.max(0, Math.min(target, maxScroll));
          track.scrollTo({ left: target, behavior: 'smooth' });
        }

        function momentum() {
          var max = track.scrollWidth - track.clientWidth;
          if (Math.abs(vx) < 0.04 || track.scrollLeft <= 0 || track.scrollLeft >= max) {
            snapToNearest();
            return;
          }
          track.scrollLeft -= vx * 16;
          vx *= 0.94;
          refresh();
          raf = window.requestAnimationFrame(momentum);
        }

        track.addEventListener('dragstart', function (e) { e.preventDefault(); });

        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          /* Butonlarda sürükleme başlatma. Görsel bağlantısı artık hızlı bakış
             tetikleyicisi olduğu için [data-quick-view-url] elenmez; aksi hâlde
             kart görselinden tutup kaydırma çalışmazdı. Sürükleme sonrası oluşan
             tıklama aşağıdaki capture dinleyicisi tarafından zaten yutuluyor. */
          if (e.target.closest('button')) return;
          down = true; moved = false;
          startX = e.clientX; startScroll = track.scrollLeft;
          lastX = e.clientX; lastT = now(); vx = 0;
          window.cancelAnimationFrame(raf);
        });
        track.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - startX;
          /* Sürükleme durumu (is-dragging + pointer capture) yalnızca eşik
             aşılınca kurulur. Basılır basılmaz kurulursa yakalanan pointer
             mouseup'ı track'e yönlendirir; tıklamanın ortak hedefi <ul> olur ve
             karttaki bağlantı hiç tıklanmamış sayılır (hızlı bakış açılmaz). */
          if (!moved) {
            if (Math.abs(dx) <= 4) { lastX = e.clientX; lastT = now(); return; }
            moved = true;
            track.classList.add('is-dragging');
            try { track.setPointerCapture(e.pointerId); } catch (err) {}
          }
          e.preventDefault();
          track.scrollLeft = startScroll - dx;
          var t = now();
          var dt = t - lastT;
          if (dt > 0) vx = (e.clientX - lastX) / dt;
          lastX = e.clientX; lastT = t;
          refresh();
        });
        function end(e) {
          if (!down) return;
          down = false;
          track.classList.remove('is-dragging');
          try { track.releasePointerCapture(e.pointerId); } catch (err) {}
          if (moved) { window.cancelAnimationFrame(raf); raf = window.requestAnimationFrame(momentum); }
        }
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } moved = false; }, true);

        track._refresh = refresh;
        refresh();
      }

      panels.forEach(bindCarousel);

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-prodtabs-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-prodtabs-panel') === id;
            p.hidden = !on;
            p.classList.toggle('is-active', on);
            if (on) {
              var track = p.querySelector('[data-prodtabs-track]');
              if (track) { track.scrollLeft = 0; if (track._refresh) track._refresh(); }
            }
          });
        });
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-prodtabs]');
      Array.prototype.forEach.call(roots, initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zey-aski-vitrini"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__zavInit) return;
    window.__zavInit = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var TURN_MS = fine ? 620 : 560, SIDE_DEF = 0.24, FRONT_DEF = 0.75, LIVE_GAP = fine ? 14 : 8;

    // ease-in-out: no sudden start, no sudden stop
    function ease(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
    function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

    function init(root) {
      if (root.__zav) return;
      root.__zav = true;
      var swingOn = !reduce && root.getAttribute('data-zav-swing') !== 'false';
      var tabs = [].slice.call(root.querySelectorAll('[data-zav-tab]'));
      var racks = [].slice.call(root.querySelectorAll('[data-zav-rack]'));
      var cap = root.querySelector('[data-zav-cap]');
      var hint = root.querySelector('[data-zav-hint]');
      var cta = root.querySelector('[data-zav-cta]');
      if (hint && !fine && hint.getAttribute('data-touch')) hint.textContent = hint.getAttribute('data-touch');
      var hint0 = hint ? hint.textContent : '';
      var H = 300, active = null, items = [], cur = null, running = false, last = 0, visible = false, plan = null;

      function heightPx() {
        return parseFloat(getComputedStyle(root).getPropertyValue('--zav-h')) || 300;
      }
      function aspect(img, def) {
        return img && img.naturalWidth ? img.naturalWidth / img.naturalHeight : def;
      }
      function makeItem(el) {
        if (el.__z) return el.__z;
        var side = el.querySelector('.zav__v--side'), front = el.querySelector('.zav__v--front');
        // e: eased turn amount 0 (side) … 1 (front); from/to/t0 drive the tween
        var s = { el: el, side: side, front: front, si: side.querySelector('img'), fi: front.querySelector('img'), e: 0, from: 0, to: 0, t0: 0, a: 0, v: 0 };
        s.sa = aspect(s.si, SIDE_DEF); s.fa = FRONT_DEF;
        s.si.addEventListener('load', function () { s.sa = aspect(s.si, SIDE_DEF); render(s); }, { once: !s.si.complete });
        s.fi.addEventListener('load', function () { s.fa = aspect(s.fi, FRONT_DEF); render(s); });
        el.__z = s;
        return s;
      }
      function loadFronts(list) {
        list.forEach(function (s) {
          var src = s.fi.getAttribute('data-src');
          if (src) { s.fi.removeAttribute('data-src'); s.fi.src = src; }
        });
      }
      function box(s, e) {
        // sub-pixel width/margins so the rail glides instead of stepping
        s.el.style.width = (H * (s.sa + (s.fa - s.sa) * e)).toFixed(2) + 'px';
        var m = (LIVE_GAP * e).toFixed(2) + 'px';
        s.el.style.marginLeft = m;
        s.el.style.marginRight = m;
      }
      function render(s) {
        var e = s.e;
        box(s, e);
        var sideOp = clamp((0.56 - e) / 0.12, 0, 1), frontOp = clamp((e - 0.44) / 0.12, 0, 1);
        s.side.style.opacity = sideOp;
        s.front.style.opacity = frontOp;
        s.side.style.transform = e <= 0 ? '' : 'perspective(900px) rotateY(' + (Math.min(1, e * 2) * -84).toFixed(2) + 'deg)';
        s.front.style.transform = e >= 1 ? '' : 'scale(' + (0.92 + 0.08 * e).toFixed(4) + ')';
        s.el.classList.toggle('is-live', e > 0.5);
      }
      function turn(s, to) {
        if (s.to === to) return;
        s.from = s.e; s.to = to; s.t0 = performance.now();
      }
      function loop(ts) {
        var dt = Math.min(64, ts - (last || ts)); last = ts;
        var now = performance.now(), busy = false;
        items.forEach(function (s) {
          if (s.e !== s.to) {
            var p = clamp((now - s.t0) / TURN_MS, 0, 1);
            s.e = p >= 1 ? s.to : s.from + (s.to - s.from) * ease(p);
            render(s); busy = true;
          }
          if (swingOn && (Math.abs(s.a) > 0.05 || Math.abs(s.v) > 0.05)) {
            s.v += (-26 * s.a - 2.3 * s.v) * dt / 1000;
            s.a = clamp(s.a + s.v * dt / 1000, -11, 11);
            s.el.style.setProperty('--sw', s.a.toFixed(2) + 'deg');
            busy = true;
          } else if (s.a !== 0) {
            s.a = 0; s.v = 0; s.el.style.setProperty('--sw', '0deg');
          }
        });
        // scroll in lock-step with the widening: same progress value, one motion
        if (plan && active) {
          var s = plan.s, span = s.to - plan.e0;
          var q = span ? clamp((s.e - plan.e0) / span, 0, 1) : 1;
          active.scrollLeft = plan.from + (plan.dest - plan.from) * q;
          if (s.e === s.to) plan = null;
          busy = true;
        }
        if (busy) requestAnimationFrame(loop); else { running = false; last = 0; }
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(loop); } }
      function impulse(s, v) { if (!swingOn || !s) return; s.v += v; kick(); }

      var capT = 0;
      function caption(s) {
        if (!cap) return;
        cap.classList.add('is-swap');
        clearTimeout(capT);
        capT = setTimeout(function () {
          cap.textContent = s ? s.el.getAttribute('data-name') : ' ';
          if (hint) hint.textContent = s ? (fine ? 'Beden seçmek için tıkla' : 'Beden seçmek için tekrar dokun') : hint0;
          cap.classList.remove('is-swap');
        }, 140);
      }
      function setHover(s) {
        if (cur === s) return;
        var prev = cur;
        if (prev) turn(prev, 0);
        cur = s;
        if (s) {
          turn(s, 1);
          var i = items.indexOf(s);
          impulse(items[i - 1], -24); impulse(items[i + 1], 24);
        }
        if (prev && prev !== s) {
          var j = items.indexOf(prev);
          if (items[j - 1] !== s) impulse(items[j - 1], 10);
          if (items[j + 1] !== s) impulse(items[j + 1], -10);
        }
        caption(s);
        kick();
      }
      function openQuickView(s) {
        var url = s.el.getAttribute('data-qv');
        if (!url) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.hidden = true;
        b.setAttribute('data-quick-view-url', url);
        root.appendChild(b);
        b.click();
        b.remove();
        if (!document.querySelector('[data-qv-drawer]')) window.location.href = url;
      }
      // Work out where the rail must end up with the tapped hanger centred: lay the
      // final state out for one synchronous measure (never painted), then restore.
      // The loop then scrolls there in step with the turn — no second correction.
      function centerItem(s) {
        var rack = active;
        if (!rack) return;
        items.forEach(function (x) { box(x, x === s ? 1 : 0); });
        var ir = s.el.getBoundingClientRect(), rr = rack.getBoundingClientRect();
        var max = rack.scrollWidth - rack.clientWidth;
        var dest = clamp(rack.scrollLeft + (ir.left + ir.width / 2) - (rr.left + rr.width / 2), 0, Math.max(0, max));
        items.forEach(function (x) { box(x, x.e); });
        plan = Math.abs(dest - rack.scrollLeft) < 1 ? null : { s: s, from: rack.scrollLeft, dest: dest, e0: s.e };
        if (plan && reduce) { rack.scrollLeft = dest; plan = null; }
        kick();
      }
      function dropIn() {
        if (reduce || !Element.prototype.animate) return;
        items.forEach(function (s, i) {
          s.el.animate(
            [{ transform: 'translateY(-40px)' }, { transform: 'translateY(0)' }],
            { duration: 520, delay: i * 55, easing: 'cubic-bezier(.3,1.35,.5,1)', fill: 'backwards' }
          );
          setTimeout(function () { impulse(s, (i % 2 ? 1 : -1) * 26); }, i * 55 + 480);
        });
      }
      function layout() {
        H = heightPx();
        items.forEach(render);
      }
      function activate(idx, animate) {
        racks.forEach(function (r, i) { r.hidden = i !== idx; });
        tabs.forEach(function (t, i) {
          var on = i === idx;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        items.forEach(function (s) { s.e = s.from = s.to = 0; render(s); });
        cur = null;
        plan = null;
        active = racks[idx];
        if (!active) return;
        active.scrollLeft = 0;
        items = [].slice.call(active.querySelectorAll('[data-zav-item]')).map(makeItem);
        layout();
        if (visible) loadFronts(items);
        caption(null);
        if (cta) {
          var u = active.getAttribute('data-zav-url');
          cta.hidden = !u;
          if (u) cta.href = u;
        }
        if (animate) dropIn();
      }

      /* tabs: click, arrow keys */
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (t.getAttribute('aria-selected') === 'true') return;
          activate(i, true);
        });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + tabs.length) % tabs.length;
          tabs[n].focus();
          activate(n, true);
        });
        // warm the next tab's side images on intent
        t.addEventListener('pointerenter', function () {
          var r = racks[i];
          if (r) [].forEach.call(r.querySelectorAll('.zav__v--side img'), function (im) { im.loading = 'eager'; });
        }, { passive: true });
      });

      /* items: hover on mouse, two taps on touch, keyboard */
      racks.forEach(function (rack) {
        if (fine) {
          var mx = 0, mt = 0;
          rack.addEventListener('mousemove', function (ev) {
            var x = ev.clientX, y = ev.clientY, now = performance.now();
            if (mt && now - mt < 100 && swingOn) {
              var vx = (x - mx) / Math.max(1, now - mt);
              items.forEach(function (s) {
                if (s === cur) return;
                var r = s.el.getBoundingClientRect();
                if (y < r.top || y > r.bottom) return;
                var c = (r.left + r.right) / 2;
                if ((mx - c) * (x - c) < 0) impulse(s, clamp(vx * 22, -45, 45));
              });
            }
            mx = x; mt = now;
            if (cur) {
              var cr = cur.el.getBoundingClientRect();
              if (x >= cr.left - 16 && x <= cr.right + 16 && y >= cr.top - 10 && y <= cr.bottom + 30) return;
            }
            var best = null, bd = 1e9;
            items.forEach(function (s) {
              var r = s.el.getBoundingClientRect();
              if (y < r.top - 10 || y > r.bottom + 30 || x < r.left - 2 || x > r.right + 2) return;
              var d = Math.abs(x - (r.left + r.right) / 2);
              if (d < bd) { bd = d; best = s; }
            });
            setHover(best);
          });
          rack.addEventListener('mouseleave', function () { mt = 0; setHover(null); });
        }
        // a finger on the rail takes over: stop any automatic centring at once
        rack.addEventListener('touchstart', function () { plan = null; }, { passive: true });
        rack.addEventListener('click', function (e) {
          var el = e.target.closest('[data-zav-item]');
          if (!el) { if (!fine) setHover(null); return; }
          var s = makeItem(el);
          if (!fine && cur !== s) {
            setHover(s);
            centerItem(s);
            return;
          }
          openQuickView(s);
        });
        rack.addEventListener('keydown', function (e) {
          var el = e.target.closest('[data-zav-item]');
          if (!el || (e.key !== 'Enter' && e.key !== ' ')) return;
          e.preventDefault();
          openQuickView(makeItem(el));
        });
        rack.addEventListener('focusin', function (e) {
          var el = e.target.closest('[data-zav-item]');
          if (el && fine) setHover(makeItem(el));
        });
        rack.addEventListener('focusout', function (e) {
          if (!rack.contains(e.relatedTarget)) setHover(null);
        });
      });
      // touch: a tap (not a swipe — swipes fire no click) anywhere but on a hanger
      // turns the garment back; swiping the rail leaves it as it is
      document.addEventListener('click', function (e) {
        if (!fine && cur && !e.target.closest('[data-zav-item]')) setHover(null);
      });

      var rT = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rT);
        rT = setTimeout(layout, 120);
      }, { passive: true });

      activate(0, false);

      /* fronts + drop-in only once the rail comes near the screen */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            visible = true;
            loadFronts(items);
            dropIn();
          });
        }, { rootMargin: '200px 0px' });
        io.observe(root);
      } else {
        visible = true;
        loadFronts(items);
      }
    }

    function boot() { [].forEach.call(document.querySelectorAll('[data-zav]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-zav]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var r = e.target.closest('[data-zav]');
      if (!r || !e.target.hasAttribute('data-zav-tab')) return;
      e.target.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zey-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CACHE_KEY = 'zig-feed-v2';
    var PROFILE_KEY = 'zig-profile-v1';
    var TTL = 6 * 60 * 60 * 1000;

    var SVG_HEART = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    var SVG_COMMENT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
    var SVG_CAROUSEL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2.4"/><path d="M4 15.5V6a2 2 0 0 1 2-2h9.5"/></svg>';
    var SVG_VIDEO = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.53.85l10-6.5a1 1 0 0 0 0-1.7l-10-6.5A1 1 0 0 0 8 5.5z"/></svg>';

    function readCache(key) {
      try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
    }
    function writeCache(key, val) {
      try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* dolu/kapalı */ }
    }
    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* -------- veri -------- */
    function normalize(data, count) {
      return (data.data || [])
        .filter(function (m) { return m.media_type === 'IMAGE' || m.media_type === 'CAROUSEL_ALBUM' || m.media_type === 'VIDEO'; })
        .slice(0, count)
        .map(function (m) {
          var children = [];
          if (m.children && m.children.data) {
            children = m.children.data.map(function (c) {
              return {
                img: c.media_type === 'VIDEO' ? (c.thumbnail_url || c.media_url) : c.media_url,
                video: c.media_type === 'VIDEO' ? c.media_url : null
              };
            });
          }
          return {
            type: m.media_type,
            thumb: m.media_type === 'VIDEO' ? (m.thumbnail_url || m.media_url) : m.media_url,
            video: m.media_type === 'VIDEO' ? m.media_url : null,
            permalink: m.permalink,
            caption: m.caption || '',
            likes: (typeof m.like_count === 'number') ? m.like_count : null,
            comments: (typeof m.comments_count === 'number') ? m.comments_count : null,
            username: m.username || '',
            children: children
          };
        })
        .filter(function (m) { return m.thumb && m.permalink; });
    }

    function slidesOf(item) {
      if (item.children && item.children.length) return item.children.slice();
      return [{ img: item.thumb, video: item.video }];
    }

    /* -------- kare üretimi -------- */
    function tileHtml(root, item, index) {
      var badge = '';
      if (item.children && item.children.length > 1) badge = '<span class="zig__badge">' + SVG_CAROUSEL + '</span>';
      else if (item.type === 'VIDEO') badge = '<span class="zig__badge">' + SVG_VIDEO + '</span>';

      var igTpl = root.querySelector('[data-zig-ig]');
      var ig = igTpl ? igTpl.innerHTML : '';

      var stats = '';
      if (item.likes != null) stats += '<span class="zig__stat">' + SVG_HEART + item.likes + '</span>';
      if (item.comments != null) stats += '<span class="zig__stat">' + SVG_COMMENT + item.comments + '</span>';

      return '<a class="zig__tile" href="' + esc(item.permalink) + '" target="_blank" rel="noopener" data-zig-index="' + index + '">' +
        '<img src="' + esc(item.thumb) + '" loading="lazy" alt="' + esc((item.caption || 'Instagram gönderisi').slice(0, 90)) + '">' +
        badge +
        '<span class="zig__overlay" aria-hidden="true"><span class="zig__ig">' + ig + '</span>' +
        (stats ? '<span class="zig__stats">' + stats + '</span>' : '') +
        '</span></a>';
    }

    /* -------- modal -------- */
    function setupModal(root) {
      var modal = root.querySelector('[data-zig-modal]');
      if (!modal || modal._zigReady) return;
      modal._zigReady = true;

      var mediaBox = modal.querySelector('[data-zig-media]');
      var dotsBox = modal.querySelector('[data-zig-dots]');
      var caption = modal.querySelector('[data-zig-caption]');
      var userLink = modal.querySelector('[data-zig-user]');
      var avatar = modal.querySelector('[data-zig-avatar]');
      var username = modal.querySelector('[data-zig-username]');
      var permalink = modal.querySelector('[data-zig-permalink]');
      var likes = modal.querySelector('[data-zig-likes]');
      var likesWrap = modal.querySelector('[data-zig-likes-wrap]');
      var comments = modal.querySelector('[data-zig-comments]');
      var commentsWrap = modal.querySelector('[data-zig-comments-wrap]');
      modal.querySelector('[data-zig-heart]').innerHTML = SVG_HEART;
      modal.querySelector('[data-zig-comment]').innerHTML = SVG_COMMENT;

      var state = { i: 0, j: 0, lastFocus: null };

      function renderSlide() {
        var item = root._zigItems[state.i];
        var slides = slidesOf(item);
        if (state.j >= slides.length) state.j = 0;
        var slide = slides[state.j];
        mediaBox.innerHTML = slide.video
          ? '<video src="' + esc(slide.video) + '" poster="' + esc(slide.img || '') + '" controls playsinline></video>'
          : '<img src="' + esc(slide.img) + '" alt="' + esc((item.caption || '').slice(0, 90)) + '">';

        dotsBox.innerHTML = '';
        if (slides.length > 1) {
          slides.forEach(function (sl, k) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'zig-modal__dot' + (k === state.j ? ' zig-modal__dot--active' : '');
            b.setAttribute('aria-label', (k + 1) + '. görsel');
            b.addEventListener('click', function () { state.j = k; renderSlide(); });
            dotsBox.appendChild(b);
          });
        }
      }

      function renderPost() {
        var item = root._zigItems[state.i];
        state.j = 0;
        var prof = root._zigProfile || {};
        var uname = item.username || prof.username || 'instagram';
        username.textContent = uname;
        userLink.href = 'https://www.instagram.com/' + encodeURIComponent(uname) + '/';
        if (prof.avatar) { avatar.src = prof.avatar; } else { avatar.removeAttribute('src'); }
        permalink.href = item.permalink;
        caption.textContent = item.caption || '';
        if (item.likes != null) { likes.textContent = item.likes; likesWrap.hidden = false; } else { likesWrap.hidden = true; }
        if (item.comments != null) { comments.textContent = item.comments; commentsWrap.hidden = false; } else { commentsWrap.hidden = true; }
        renderSlide();
      }

      function step(dir) {
        var n = root._zigItems.length;
        state.i = (state.i + dir + n) % n;
        renderPost();
      }

      function open(index) {
        if (!root._zigItems || !root._zigItems.length) return;
        state.i = index;
        state.lastFocus = document.activeElement;
        renderPost();
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('zig-lock');
        document.addEventListener('keydown', onKey);
        var card = modal.querySelector('[data-zig-card]');
        if (card) card.focus();
      }

      function close() {
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('zig-lock');
        document.removeEventListener('keydown', onKey);
        mediaBox.innerHTML = '';
        if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
      }

      function onKey(e) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') step(1);
        else if (e.key === 'ArrowLeft') step(-1);
      }

      modal.querySelectorAll('[data-zig-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      modal.querySelector('[data-zig-prev]').addEventListener('click', function () { step(-1); });
      modal.querySelector('[data-zig-next]').addEventListener('click', function () { step(1); });

      root._zigModalApi = {
        open: open,
        refreshNav: function () {
          var single = !root._zigItems || root._zigItems.length < 2;
          modal.querySelector('[data-zig-prev]').hidden = single;
          modal.querySelector('[data-zig-next]').hidden = single;
        }
      };

      var grid = root.querySelector('[data-zig-grid]');
      if (grid) {
        grid.addEventListener('click', function (e) {
          var tile = e.target.closest ? e.target.closest('.zig__tile') : null;
          if (!tile || !grid.contains(tile)) return;
          var idx = tile.getAttribute('data-zig-index');
          if (idx == null) return; // yedek görsel: normal link
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          open(parseInt(idx, 10) || 0);
        });
      }
    }

    /* -------- init -------- */
    function fetchProfile(token) {
      var cached = readCache(PROFILE_KEY);
      if (cached && Date.now() - cached.t < TTL && cached.username) return Promise.resolve(cached);
      return fetch('https://graph.instagram.com/me?fields=username,profile_picture_url&access_token=' + encodeURIComponent(token))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.username) return null;
          var prof = { t: Date.now(), username: d.username, avatar: d.profile_picture_url || '' };
          writeCache(PROFILE_KEY, prof);
          return prof;
        })
        .catch(function () { return null; });
    }

    function applyItems(root, items) {
      var grid = root.querySelector('[data-zig-grid]');
      if (!grid) return;
      root._zigItems = items;
      grid.innerHTML = items.map(function (it, i) { return tileHtml(root, it, i); }).join('');
      grid.classList.remove('zig__grid--empty');
      setupModal(root);
      if (root._zigModalApi) root._zigModalApi.refreshNav();
    }

    function initRoot(root) {
      if (root.dataset.zigInit === '1') return;
      root.dataset.zigInit = '1';

      var token = root.dataset.token;
      var count = parseInt(root.dataset.count, 10) || 8;
      if (!token) return; // token yok: sunucu tarafı yedek görseller kalır

      var profileP = fetchProfile(token);

      var cached = readCache(CACHE_KEY);
      if (cached && Date.now() - cached.t < TTL && cached.items && cached.items.length) {
        profileP.then(function (p) { root._zigProfile = p; });
        applyItems(root, cached.items.slice(0, count));
        return;
      }

      var url = 'https://graph.instagram.com/me/media' +
        '?fields=id,media_type,media_url,thumbnail_url,permalink,caption,username,like_count,comments_count,children{media_type,media_url,thumbnail_url}' +
        '&limit=' + Math.max(count, 8) +
        '&access_token=' + encodeURIComponent(token);

      Promise.all([
        fetch(url).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); }),
        profileP
      ])
        .then(function (res) {
          var items = normalize(res[0], count);
          if (!items.length) throw new Error('empty');
          root._zigProfile = res[1];
          writeCache(CACHE_KEY, { t: Date.now(), items: items });
          applyItems(root, items);
        })
        .catch(function () {
          if (cached && cached.items && cached.items.length) {
            profileP.then(function (p) { root._zigProfile = p; });
            applyItems(root, cached.items.slice(0, count));
          }
        });
    }

    function initAll() {
      document.querySelectorAll('[data-zig]').forEach(initRoot);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zey-scroll-story-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.zssInit === '1') return;
      root.dataset.zssInit = '1';

      var win = root.querySelector('[data-zss-window]');
      var track = root.querySelector('[data-zss-headings]');
      var headings = Array.prototype.slice.call(root.querySelectorAll('[data-zss-heading]'));
      var count = headings.length;
      if (!win || !track || count === 0) return;

      var desktop = window.matchMedia('(min-width: 768px)');
      var ticking = false;

      function setActive(idx) {
        for (var i = 0; i < headings.length; i++) {
          headings[i].classList.toggle('is-active', i === idx);
        }
      }

      function update() {
        ticking = false;
        if (!desktop.matches) {
          track.style.transform = 'translate3d(0,0,0)';
          setActive(0);
          return;
        }
        var rect = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var total = root.offsetHeight - vh;
        var p = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
        var activeFloat = p * (count - 1);
        var h = win.clientHeight;
        track.style.transform = 'translate3d(0,' + (-activeFloat * h).toFixed(2) + 'px,0)';
        setActive(Math.round(activeFloat));
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-zss]');
      Array.prototype.forEach.call(roots, initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
